import {createHashHistory, createBrowserHistory} from 'history'

const handleCallbackUrlForDeployment = () => {
  // In deployment mode, convert browser history callback URLs to hash-based URLs
  // This ensures proper routing when the app is deployed in environments where
  // the server doesn't handle client-side routing
  const {pathname, origin, search, hash} = window.location

  if (process.env.REACT_APP_ENV === 'deployment' && pathname === '/callback') {
    const newUrl = `${origin}/#${pathname}${search}${hash}`
    window.history.replaceState(null, '', newUrl)
  }
}

// Handle callback URL transformation for deployment environment
handleCallbackUrlForDeployment()

export const history =
  process.env.REACT_APP_ENV === 'deployment'
    ? createHashHistory({basename: `${process.env.REACT_APP_ROUTER_PATH}`})
    : createBrowserHistory()
